<template>
  <div>
    <material-card
      :text="`${title}`"
      color="orange"
      title="Draft Opportunities">
      <template v-slot:download>
        <Can
          i="report"
          a="inventory">
            <v-btn style="background: #f5f5f5; color: black;" small @click="downloadRecords" :loading="downloadingRecords"><v-icon>mdi-download</v-icon> &nbsp;Download</v-btn>
        </Can>
      </template>
      <v-layout
        class="account-filters ml-2 mr-2"
        justify-start
        align-center
        wrap>
        <v-flex md3>
            <v-text-field
              ref="searchInputField"
              v-model.trim="searchInput"
              label="Search here..."
              clearable
            />
        </v-flex>
        <v-flex
          md3 >
          <v-select
            v-model="statusFilter"
            :items="statusItems"
            item-text="text"
            item-value="value"
            attach
            label="Status"
            multiple
          />
        </v-flex>
        <v-flex md1>
          <v-checkbox
            v-model="deletedFilter"
            value="1"
            false-value="0"
            true-value="1"
            color="orange"
            label="Deleted"
          />
        </v-flex>
      </v-layout>
      <v-layout
        v-show="selected.length > 0"
        align-end
        justify-end
        row
        fill-height
        class="mass-update-actions"
        transition="fade-transition">
        <v-flex
          md4
          align-self-center>
          <p class="subtitle-1 mb-0"><span class="font-weight-black">({{ selected.length }})</span> accounts selected</p>
        </v-flex>
        <v-flex
          md8
          style="text-align: right">
          <v-btn
            v-if="deletedFilter == '1'"
            small
            class="mr-2"
            color="orange"
            @click="unArchiveAccount(selected)" ><v-icon left>reply</v-icon>Restore Accounts</v-btn>
          <!-- <Can
            I="manage"
            a="admin">
            <v-btn
              small
              class="mr-2"
              color="orange"
              @click="updateLastDateValidated = true" >Update Last Validated</v-btn>
          </Can> -->
        </v-flex>
      </v-layout>
      <v-data-table
        ref="accountList"
        :headers="getHeaders"
        :items="records"
        v-model="selected"
        hide-actions
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        item-key="opportunity_id"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" >
            <!-- <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              />
            </td> -->
            <td>
              <v-layout
                align-center
                justify-center>
                <Can
                  i="write"
                  a="inventory">
                  <v-icon
                    small
                    title="View"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="openItem('view', props.item)">visibility</v-icon>
                </Can>
                <Can
                  i="write"
                  a="inventory">
                  <v-icon
                    v-if="deletedFilter != '1'"
                    small
                    title="Delete"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="flagAccount(props.item)">delete</v-icon>
                  <v-icon
                    v-if="deletedFilter == '1'"
                    small
                    title="Restore"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="unArchiveAccount(props.item)">restore_page</v-icon>
                </Can>
              </v-layout>
            </td>
            <td>{{ props.item.opportunity_id }}</td>
            <td>
              <v-chip
                :color="statusColor(props.item.status).bg"
                :text-color="statusColor(props.item.status).text"
                small>
                {{ props.item.status }}
              </v-chip>
            </td>
            <td>{{ props.item.created_at }}</td>
            <td>{{ props.item.updated_at }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-progress-linear
        v-if="loadingRecords"
        v-slot:progress
        color="orange"
        indeterminate/>
      <div class="text-xs-center mt-3">
        <v-btn :disabled="!nextPaginationKey || loadingRecords" small @click="showNextData">LOAD MORE...</v-btn>
      </div>
    </material-card>
    <!-- MODAL -->
    <v-dialog
      v-model="recordDetailsDialog"
      max-width="900px"
      scrollable>
      <v-card>
        <v-card-title class="headline">
          Draft Opportunity Details
        </v-card-title>
        <v-card-text>
          <v-container v-if="selectedRecord">
            <v-layout row wrap>
              <v-flex xs12 sm6 class="mb-3">
                <div class="detail-label">Status</div>
                <v-chip
                  :color="statusColor(selectedRecord.status).bg"
                  :text-color="statusColor(selectedRecord.status).text"
                  small>
                  {{ selectedRecord.status }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm6 class="mb-3">
                <div class="detail-label">Opportunity ID</div>
                <div class="detail-value">{{ selectedRecord.opportunity_id }}</div>
              </v-flex>
              <v-flex xs12 sm6 class="mb-3">
                <div class="detail-label">Created At</div>
                <div class="detail-value">{{ selectedRecord.created_at }}</div>
              </v-flex>
              <v-flex xs12 sm6 class="mb-3">
                <div class="detail-label">Updated At</div>
                <div class="detail-value">{{ selectedRecord.updated_at }}</div>
              </v-flex>
              <v-flex xs12>
                <div class="detail-label mb-2">Details</div>
                <v-card outlined class="details-card">
                  <v-card-text>
                    <div
                      v-if="formattedDetailsEntries.length"
                      class="details-grid">
                      <div
                        v-for="entry in formattedDetailsEntries"
                        :key="entry.key"
                        class="details-row">
                        <div class="detail-key">{{ entry.key }}</div>
                        <div class="detail-value detail-value--wrap">{{ entry.value }}</div>
                      </div>
                    </div>
                    <div v-else class="detail-value">No details available</div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="orange darken-1"
            text
            @click="recordDetailsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-model="updateLastDateValidated"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Last Validated Date</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md10
                xl10>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="lastDateVal"
                      label="Last Date Validated"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="lastDateVal"
                    @input="menu2 = false"/>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout
            align-end
            justify-end>
            <v-btn
              color="orange darken-1"
              text
              @click="updateLastDateValidated = false">Close</v-btn>
            <v-btn
              :loading ="lastDateValidatedStatus"
              color="orange darken-1"
              text
              @click="updateLastDateValidatedField()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

import {debounce} from '../../../utils/helper'

export default {

  props: {
    title: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    },
    selectedDraftId: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    searchInput: '',
    selected: [],
    selectedMiscFilter: [],
    selectedAcctStatus: ['draft'],
    recordDetailsDialog: false,
    selectedRecord: null,
    statusItems: [
      {
        text: 'Draft',
        value: 'draft'
      },
      {
        text: 'Registered',
        value: 'registered'
      },
      {
        text: 'Submitted',
        value: 'submitted'
      },
      {
        text: 'Failed',
        value: 'failed'
      },
    ],
  }),
  mounted() {
    this.$store.commit('admin/draftOpportunities/resetTableFilters')
    this.$store.commit('admin/draftOpportunities/clearRecords')
  },
  computed: {
    ...mapState('admin/draftOpportunities', ['records', 'tableFilters', 'loadingRecords', 'downloadingAccount', 'nextPaginationKey',  'downloadingRecords']),
    ...mapState('admin', ['customers']),
    ...mapGetters({
    getHeaders: 'admin/draftOpportunities/getTableHeaders'
    }),
    statusFilter: {
      get: function() {
        return this.tableFilters.status
      },
      set: function(value) {
        this.tableFilters.status = value
      }
    },
    deletedFilter: {
      get: function(){
        return this.tableFilters.is_deleted
      },
      set: function(value) {
        this.tableFilters.is_deleted = value
      }
    },
    formattedDetailsEntries () {
      const details = this.parseDetails(this.selectedRecord && this.selectedRecord.details)

      if (!details || Array.isArray(details) || typeof details !== 'object') {
        return []
      }

      return Object.keys(details).map(key => ({
        key,
        value: this.formatDetailValue(details[key])
      }))
    }
  },
  methods: {
    onHeaderButtonClick() {
      // TODO: Implement button action
      this.$emit('header-button-click')
    },
    statusColor (status) {
      const map = {
        draft:      { bg: '#FF9800', text: '#fff' },
        registered: { bg: '#2196F3', text: '#fff' },
        submitted:  { bg: '#4CAF50', text: '#fff' },
        failed:     { bg: '#FFEBEE', text: '#fff' }
      }
      return map[(status || '').toLowerCase()] || { bg: '#F5F5F5', text: '#616161' }
    },
    scrollToSearchInput () {
      const searchField = this.$refs.searchInputField
      const searchFieldElement = searchField && searchField.$el

      if (!searchFieldElement) return

      searchFieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' })

      this.$nextTick(() => {
        const input = searchFieldElement.querySelector('input')

        if (input) {
          input.focus()
        }
      })
    },
    showNextData() {
      this.$store.dispatch('admin/draftOpportunities/getRecords', { paginate: 'next'})
    },
    downloadFinished () {
      this.pagination.rowsPerPage = 10
    },
    verifyContactsValue (contactValue) {
      if (contactValue == 'None') {
        contactValue = []
      } else {
        contactValue = typeof contactValue === "string" ?
        JSON.parse(contactValue) : contactValue
      }
      return contactValue
    },
    openItem (action, item) {
      this.selectedRecord = { ...item }
      this.recordDetailsDialog = true
    },
    parseDetails (details) {
      if (!details) return null

      if (typeof details === 'string') {
        try {
          return JSON.parse(details)
        } catch (error) {
          return { raw: details }
        }
      }

      return details
    },
    formatDetailValue (value) {
      if (value === null || value === undefined || value === '') return '-'

      if (Array.isArray(value) || typeof value === 'object') {
        return JSON.stringify(value, null, 2)
      }

      return String(value)
    },
    flagAccount (data) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/draftOpportunities/delete', data)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: 'Do you want to delete this OPX ID:' + data.opportunity_id,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    cloneAccount (item) {
      this.$store.commit('admin/openClonedAccount', {
        show: true,
        type: 'new',
        showSelectCustomer: false,
        fields: { ...item, Acct_ID: null },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Create',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewAccount', fields)
        }
      })
    },
    updateLastDateValidatedField () {
      let selectedAccount = {
        updatedLastDateValidated: this.lastDateVal,
        selected: this.selected
      }
      this.$store.dispatch('admin/accountInventory/updateFieldLastDateValidated', selectedAccount)
    },
    onShowLogs (account) {
      this.$store.dispatch('showLogRecords', account.Acct_ID)
    },
    unArchiveAccount (account) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/accountInventory/unArchive', account)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: Array.isArray(account) ? 'Do you want to restore the selected accounts:' : 'Do you want to restore this Account ID: ' + account.Acct_ID,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    checkFieldPerm () {
      this.blurConfig.isBlurred = this.$store.state.viewCustomFields.isAllowed
      return true
    },
    daysMarkedAsUnknown (item) {
      let currentDate = new Date()
      let markedDate = new Date(item)
      let cDate = currentDate.valueOf()
      let mDate = markedDate.valueOf()

      let since_days = (cDate - mDate) / 1000 / 86400
      since_days = Math.round(since_days - 0.5)
      return since_days + (since_days > 1 ? ' Days ago.' : ' Day ago.')
    },
    downloadRecords () {
      this.$store.dispatch('admin/draftOpportunities/downloadRecords')
    },
    onRowClick (e) {
      let currentHoveredItem = document.querySelector('.current-item')
      if (currentHoveredItem) {
        currentHoveredItem.classList.remove('current-item')
      }
      e.target.closest('tr').classList.add('current-item')
    }
  },
  watch: {
    selectedDraftId: {
      handler: function (selection) {
        if (!selection || !selection.value) return

        this.searchInput = selection.value
      },
      deep: true
    },
    searchInput: debounce(function (newVal, oldVal) {
      this.$store.state['admin/draftOpportunities'].nextPaginationKey = null
      this.$store.state['admin/draftOpportunities'].tableFilters.opportunity_id = newVal
      this.$store.dispatch('admin/draftOpportunities/getRecords')
    }, 1000),
    // searchField: function (newVal, oldVal) {
    //   // clear search input
    //   this.searchInput = ''
    //   this.$store.commit('admin/accountInventory/removeSearchValue')
    //   this.$store.state['admin/accountInventory'].nextPaginationKey = null
    //   this.$store.state['admin/accountInventory'].accountDataFilters.field = newVal
    // },
    statusFilter: debounce(function (val) {
      this.$store.state['admin/draftOpportunities'].nextPaginationKey = null
      this.$store.state['admin/draftOpportunities'].tableFilters.status = val
      this.$store.dispatch('admin/draftOpportunities/getRecords')
    }, 1000),
    // agreementFilter: function (val) {
    //   this.$store.state['admin/accountInventory'].nextPaginationKey = null
    //   this.$store.state['admin/accountInventory'].accountDataFilters.Agreement = val
    //   this.$store.dispatch('admin/accountInventory/getAccounts')
    // },
    

    // archivedAcctStatus: function (val) {
    //   this.$store.state['admin/accountInventory'].nextPaginationKey = null
    //   let accountStatuses = [] 
    //   if (val == '1') {
    //     accountStatuses = ['SUSPENDED', 'Moved to Client']
    //   } else {
    //     accountStatuses = ['ACTIVE', 'New']
    //   }
    //   this.$store.state['admin/accountInventory'].accountDataFilters.Acct_Status = accountStatuses
    // },
    deletedFilter: function (val) {
      this.$store.state['admin/draftOpportunities'].nextPaginationKey = null
      this.$store.state['admin/draftOpportunities'].tableFilters.is_deleted = val
      this.$store.dispatch('admin/draftOpportunities/getRecords')
    },
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}

.masterDropdown {
  margin-bottom: 0;
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
    color: #fff !important;
  }
  .theme--light.v-select .v-select__selections {
    color: #fff !important;
  }
  .theme--light.v-icon {
    color: #fff;
  }
}
.v-progress-linear {
      margin: 0;
      bottom: -15px;
  }

.mass-update-actions {
  background: rgba(65, 179, 223, 0.3);
}

.detail-label {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.detail-key {
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}

.detail-value {
  color: #111827;
  font-size: 14px;
  line-height: 1.5;
}

.detail-value--wrap {
  white-space: pre-wrap;
  word-break: break-word;
}

.details-card {
  border: 1px solid #e5e7eb;
}

.details-grid {
  display: grid;
  gap: 12px;
}

.details-row {
  display: grid;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}

.details-row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
</style>